export default function getDrawerUser(selectedUser, currentUser) {
  return selectedUser || currentUser
}
